import { cn } from "@theprelude/core";
import { ButtonHTMLAttributes, forwardRef, type JSX } from "react";
import { Loading } from "../icon-helpers/loading";
import { Button } from "./button";

export interface ButtonIconProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  icon: JSX.Element;
  loading?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, ButtonIconProps>(
  ({ className, icon, loading, ...props }, ref) => {
    return (
      <Button
        type="button"
        size="none"
        ref={ref}
        {...props}
        className={cn(
          "text-secondary-foreground hover:text-primary-foreground h-max w-max",
          className,
        )}
      >
        {loading ? <Loading /> : icon}
      </Button>
    );
  },
);

IconButton.displayName = "IconButton";
